// Vendor
import * as React from 'react';

// Internal
import { ChartCovidSlump } from '@src/charts/ChartCovidSlump';
import { Image } from '@src/components/Image';
import { SlideReveal } from '@src/components/SlideReveal';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

const CovidRetailSlump: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        Online Thrifting is a Bright Spot in Broader Covid Retail Slump
      </h1>

      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="tup-body max-w-2xl"
      >
        With consumers seeking bargains from home, online secondhand is set to
        grow <b>69%</b> between 2019 and 2021, while the broader retail sector
        is projected to shrink <b>15%</b>.
      </p>
      <div className="hidden md:block" style={{ height: 480, maxWidth: 850 }}>
        <ChartCovidSlump />
      </div>
      <SlideReveal>
        <Image
          alt="Chart Growth Indexed to 2019 Market Size"
          addLink={true}
          className="block md:hidden"
          fileName="1c-chart-mobile.png"
        />
      </SlideReveal>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 3}
        className="tup-description"
      >
        Growth Indexed to 2019 Market Size
      </p>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 4}
        className="tup-source"
      >
        GlobalData Market Sizing and Growth Estimates
      </p>
    </div>
  );
};

export { CovidRetailSlump };
